interface MobileNavProps {
    el: HTMLDivElement;
    props: {
        collapseOthers?: boolean;
        itemClass?: string;
        triggerClass?: string;
        collapsibleClass?: string;
        backTriggerClass?: string;
    };
}

const ITEM_CLASS = 'mobile-nav-item';
const TRIGGER_CLASS = 'mobile-nav-item-btn';
const COLLAPSIBLE_CLASS = 'mobile-nav-item-content-wrapper';
const BACK_TRIGGER_CLASS = 'mobile-nav-back-btn';
const OVERFLOW_PARENTS_SELECTOR = '.mobile-nav-container, .mobile-nav-item-content-wrapper';

const MobileNav = ({ el, props }: MobileNavProps): void => {
    const {
        // collapseOthers,
        itemClass = ITEM_CLASS,
        triggerClass = TRIGGER_CLASS,
        collapsibleClass = COLLAPSIBLE_CLASS,
        backTriggerClass = BACK_TRIGGER_CLASS,
    } = props;

    // Accordion({ el, props });
    const itemEls = el.querySelectorAll(`.${itemClass}`);

    // Add accordion functionality
    itemEls.forEach(itemEl => {
        const triggerEl: HTMLButtonElement | null = itemEl.querySelector(`.${triggerClass}`);
        const collapsibleEl: HTMLDivElement | null = itemEl.querySelector(`.${collapsibleClass}`);

        if (!triggerEl || !collapsibleEl) {
            return;
        }

        // set default as close if no is-open class
        if (!itemEl.classList.contains('is-open')) {
            // collapsibleEl.style.height = '0px';
            triggerEl.setAttribute('aria-expanded', 'false');
        }

        triggerEl.addEventListener('click', () => {
            if (triggerEl.classList.contains('disabled')) {
                return;
            }

            // To disable the parent overflow so we don't have multiple scrollbar with the parent (mostly on mobile landscape issue)
            const affectedParent = itemEl.closest(OVERFLOW_PARENTS_SELECTOR);
            if (affectedParent) {
                affectedParent.scrollTop = 0;
                affectedParent.classList.add('child-is-open');
            }

            itemEl.classList.add('is-open');
            triggerEl.classList.remove('disabled');
            triggerEl.setAttribute('aria-expanded', 'true');
        });

        const backTriggerEl: HTMLButtonElement | null = itemEl.querySelector(`.${backTriggerClass}`);
        if (!backTriggerEl) {
            return;
        }

        backTriggerEl.addEventListener('click', () => {
            if (backTriggerEl.classList.contains('disabled')) {
                return;
            }

            if (itemEl.classList.contains('is-open')) {
                // To enable the parent overflow after disabled when open on the child
                const affectedParent = itemEl.closest(OVERFLOW_PARENTS_SELECTOR);
                if (affectedParent) {
                    affectedParent.scrollTop = 0;
                    affectedParent.classList.remove('child-is-open');
                }

                itemEl.classList.remove('is-open');
                triggerEl.classList.remove('disabled');
                triggerEl.setAttribute('aria-expanded', 'false');
            }
        });

        // attachEnterAsClick(triggerEl);
    });
};

interface CloseAllMenuMobileNavProps {
    el: HTMLDivElement;
}

export const closeAllMenuMobileNav = ({ el }: CloseAllMenuMobileNavProps): void => {
    const allIsOpenItems = el.querySelectorAll(`.is-open`);
    allIsOpenItems.forEach(itemEl => {
        const triggerEl = itemEl.querySelector(`.${TRIGGER_CLASS}`) as HTMLButtonElement | null;
        const collapsibleEl = itemEl.querySelector(`.${COLLAPSIBLE_CLASS}`) as HTMLDivElement | null;

        if (!triggerEl || !collapsibleEl) {
            return;
        }
        itemEl.classList.remove('is-open');
        el.setAttribute('aria-expanded', 'false');
        triggerEl?.setAttribute('aria-expanded', 'false');
    });

    const allChildIsOpenItems = el.querySelectorAll(`.child-is-open`);
    allChildIsOpenItems.forEach(itemEl => {
        itemEl.scrollTop = 0;
        itemEl.classList.remove('child-is-open');
    });
};

export default MobileNav;
